import { buildNotesWithCurrencyRate } from "../../../../utils/pdf/page";
import { buildAutoNote } from "../../../../utils/pdf/buildAutoTable";
import { buildIrasMainCompSections } from "./buildIrasMainCompSections";
import { createIrasPdfGenerator } from "./layoutConfig";
import { renderIrasChargeableIncomeTable } from "./renderIrasChargeableIncomeTable";
import { renderIrasMainCompSections } from "./renderIrasMainCompSections";
import { renderIrasUnabsorbedSummary } from "./renderIrasUnabsorbedSummary";
import { getIrasNoteTableOptions } from "./tableSpacing";

const generateIrasMainCompPdf = ({
  forView,
  company,
  currency,
  currencyRate,
  netProfitBeforeTax,
  referenceData,
  unutilisedCapitalAllowances,
  unutilisedLosses,
  unutilisedDonations,
  corporateIncomeTaxRebate,
  currentYearRebate,
  isStartup,
  taxPreviouslyAssessed,
  computedSummary,
  unabsorbedSummary,
  comments,
  reviewNote,
  isExcel = false,
  pdfDensity = "default",
  pdfSpacingOptions,
  scheduleName = "Main Tax Computation",
}) => {
  const pdf = createIrasPdfGenerator(isExcel);
  const schedule = { name: scheduleName };
  const currencyView = currency ?? company.currency;
  const isCompact = pdfDensity === "compact";
  const tableSpacingOptions = {
    density: pdfDensity,
    overrides: pdfSpacingOptions,
  };

  const sections = buildIrasMainCompSections({
    netProfitBeforeTax,
    referenceData,
    unutilisedCapitalAllowances,
    unutilisedDonations,
    unutilisedLosses,
  });
  const renderResult = renderIrasMainCompSections({
    company,
    currencyRate,
    currencyView,
    forView,
    isCompact,
    pdf,
    reviewNote,
    schedule,
    sections,
    tableSpacingOptions,
    unutilisedCapitalAllowances,
    unutilisedDonations,
    unutilisedLosses,
  });
  const chargeableIncomeResult = renderIrasChargeableIncomeTable({
    chargeableIncomeBeforeExemptAmount:
      renderResult.chargeableIncomeBeforeExemptAmount,
    company,
    computedSummary,
    corporateIncomeTaxRebate,
    currentYearRebate,
    currencyView,
    forView,
    isCompact,
    isStartup,
    mainCompBodyRowCount: renderResult.bodyRowCount,
    pdf,
    reviewNote: renderResult.reviewNote,
    schedule,
    tableSpacingOptions,
    taxPreviouslyAssessed,
  });

  buildAutoNote(
    pdf,
    forView,
    company,
    schedule,
    buildNotesWithCurrencyRate(company, comments),
    chargeableIncomeResult.reviewNote,
    [],
    false,
    "Notes/Comments",
    getIrasNoteTableOptions(pdf, tableSpacingOptions),
  );

  renderIrasUnabsorbedSummary({
    company,
    currencyRate,
    currencyView,
    unabsorbedSgdSummary: renderResult.unabsorbedSgdSummary,
    pdf,
    tableSpacingOptions,
    unabsorbedSummary,
  });

  return pdf.getDoc(forView, company, schedule);
};

export default generateIrasMainCompPdf;
